// Fase 1A — Servicio de autenticación (thin wrapper de axios). Sin lógica nueva ni cambio de contrato.
// Encapsula: GET /auth/me, POST /auth/login-admin, POST /auth/login-operativo.
import api from "@/lib/api";

export const me = () => api.get("/auth/me");

export const loginAdmin = (email, password) =>
  api.post("/auth/login-admin", { email, password });

export const loginOperativo = (codigo_operativo, usuario_corto, nip_acceso) =>
  api.post("/auth/login-operativo", { codigo_operativo, usuario_corto, nip_acceso });
